import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/router/views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/product/:name(.*)_:id(.*)',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/router/views/ProductDetail.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () => import(/* webpackChunkName: "PageNotFound" */ '@/router/views/PageNotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
